<template>
  <ModalMain ref="modal" @onClose="handleModalClose">
    <div class="modal-wrapper">
      <div class="d-flex justify-content-center">
        <SuccessIcon v-if="modalType === 'success'"/>
        <ErrorIcon v-if="modalType === 'error'"/>
      </div>
      <div class="message">{{ message }}</div>
    </div>
  </ModalMain>
</template>

<script>
import SuccessIcon from "@/components/Common/Icons/SuccessIcon.vue";
import ErrorIcon from "@/components/Common/Icons/ErrorIcon.vue";
import ModalMain from "@/components/Components/ModalMain/ModalMain.vue";

export default {
  name: 'ModalNotifications',
  components: {ModalMain, ErrorIcon, SuccessIcon},
  watch: {
    isModalOpen(newVal) {
      if (newVal) {
        this.$refs.modal.showModal();
      } else {
        this.$refs.modal.hideModal();
      }
    },
  },
  computed: {
    isModalOpen() {
      return this.$store.state.utils.notificationModal.isOpen
    },
    modalType() {
      return this.$store.state.utils.notificationModal.type
    },
    message() {
      return this.$store.state.utils.notificationModal.message
    },
  },
  methods: {
    handleModalClose() {
      this.$store.dispatch("utils/closeNotificationModal");
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  font-family: $font-bold;
  color: $color-brown;

  .message {
    margin-top: 30px;
    text-align: center;
  }
}

@media screen and (min-width: 768px) {
  .modal-contacts-wrapper {
    .title {
      font-size: $title-h5;
    }

    .subtitle {
      font-size: $paragraph-1;
    }
  }
}
</style>